module.exports = "/_next/static/images/e6538f8d3afbdbe20756752b74a65f78-logo-nu-xs.png.webp";